import { useMemo } from "react";
import { useFilterSettingsStore, useMapStore } from "..";
import IEntityWithIcon from "../interfaces/IEntityWithIcon";
import ISaleComp from "../interfaces/ISaleComp";
import useVisibleOnMapCompanyIds from "./useVisibleOnMapCompanyIds";
import useVisibleSaleCompsOnMap from "./useVisibleSaleCompsOnMap";

export default function (): ISaleCompWithIcon[] {
    const mapStore = useMapStore();
    const { filters: { companySettings: companyFilters } } = useFilterSettingsStore();
    const saleComps = useVisibleSaleCompsOnMap();
    const visibleOnMapCompanyIds = useVisibleOnMapCompanyIds();

    const companiesSaleComps = useMemo(() =>
        companyFilters.includeSaleComps
            ? saleComps.filter(sc => sc.pipedriveBuyerId && visibleOnMapCompanyIds.includes(sc.pipedriveBuyerId))
            : []
        , [saleComps, visibleOnMapCompanyIds, companyFilters.includeSaleComps]);

    return useMemo(() => companiesSaleComps.map((sc) => {
        const icon =
            sc.pipedriveBuyerId && mapStore.loadedLogoCompanyIds.includes(sc.pipedriveBuyerId)
                ? `location-marker-company-${sc.pipedriveBuyerId}`
                : "sale-comp-marker";

        return { ...sc, icon };
    }), [companiesSaleComps, mapStore.loadedLogoCompanyIds]);
}

type ISaleCompWithIcon = ISaleComp & IEntityWithIcon